import React, { PureComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { paths } from '../../../constants/routes/urls';
import { EmailVerified } from '../../templates/EmailVerified';
import { URLInvalidMsg } from '../../templates/URLInvalidMsg';

type Props = {
  emailVerified: boolean;
  verifyEmailError: string;
  handleVerifyEmail: (oobCode: string) => void;
} & RouteComponentProps;

export default class extends PureComponent<Props> {
  componentDidMount() {
    const {
      emailVerified,
      verifyEmailError,
      location: { state },
      handleVerifyEmail,
    } = this.props;

    if (!state) {
      return;
    }

    const { oobCode } = state as { oobCode: string };

    if (!emailVerified && !verifyEmailError && oobCode) {
      handleVerifyEmail(oobCode);
    }
  }

  handleBackToLogin = () => {
    this.props.history.replace(paths.login);
  };

  //For now redirect to external bigmac site
  onClickMail = () => {
    window.open(`${process.env.REACT_APP_WP_ENDPOINT}/contact`, '_blank');
  };

  render = (): React.ReactElement => {
    const { emailVerified, verifyEmailError } = this.props;
    return emailVerified ? (
      <EmailVerified />
    ) : (
      <URLInvalidMsg
        backToLogin={this.handleBackToLogin}
        onClickMail={this.onClickMail}
        err={verifyEmailError}
      />
    );
  };
}
